var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3370_2812)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M512 0H0V512H512V0Z",
    fill: "#73AF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.873 208.131C396.523 205.894 393.28 206.007 393.025 208.256C385.222 277.028 326.884 330.46 256.001 330.46C185.139 330.46 126.784 277.03 118.975 208.258C118.72 206.009 115.479 205.897 115.127 208.134C114.044 215.051 113.45 222.127 113.45 229.35C113.45 308.002 177.284 371.857 255.999 371.857C334.739 371.857 398.547 308.002 398.547 229.35C398.55 222.127 397.956 215.05 396.873 208.131Z",
    fill: "#FFE15A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.237 149.272L243.929 180.181L211.348 180.433C209.562 180.447 208.821 182.726 210.258 183.787L236.47 203.142L226.642 234.207C226.102 235.91 228.042 237.32 229.495 236.281L256.001 217.333L282.508 236.279C283.961 237.318 285.901 235.909 285.361 234.206L275.534 203.141L301.745 183.786C303.182 182.725 302.441 180.445 300.655 180.432L268.074 180.18L257.766 149.27C257.2 147.576 254.802 147.576 254.237 149.272Z",
    fill: "#FFE15A"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 60,
    fill: "#FF0043"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 452,
    width: 512,
    height: 60,
    fill: "#FF0043"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3370_2812"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMr);
export default __webpack_public_path__ + "static/media/mr.44f4257d96d1c3391639c28623c211ec.svg";
export { ForwardRef as ReactComponent };